var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5991 47.1981C40.6324 47.1981 51.1981 36.6324 51.1981 23.5991C51.1981 10.5657 40.6324 0 27.5991 0C14.5657 0 4 10.5657 4 23.5991C4 36.6324 14.5657 47.1981 27.5991 47.1981Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6352 29.246C28.7068 28.6199 29.7422 28.0179 30.8018 27.4038C30.9222 27.5724 31.0426 27.7289 31.1509 27.8975C32.2586 29.4747 34.0165 30.1249 35.7503 29.5831C36.5209 29.3423 37.0989 28.8968 37.1952 28.0419C37.2915 27.2352 36.9183 26.6212 36.232 26.2479C35.353 25.7784 34.438 25.369 33.5229 24.9596C32.3309 24.4178 31.1509 23.876 30.2479 22.9128C28.791 21.3596 28.4539 19.5054 29.0439 17.5067C29.6098 15.5561 31.0667 14.5207 32.9931 14.0872C34.0527 13.8464 35.1242 13.8825 36.1838 14.0992C37.9296 14.4605 39.1457 15.4959 40.0367 17.0852C39.0253 17.7354 38.0139 18.3856 37.0025 19.0358C36.8099 18.7709 36.6654 18.5421 36.4848 18.3134C35.8226 17.4585 34.9316 17.2538 33.9323 17.4585C33.3302 17.5789 32.8968 17.9521 32.7403 18.5782C32.5837 19.2164 32.668 19.8425 33.1978 20.2639C33.6433 20.6131 34.161 20.89 34.6667 21.1549C35.9791 21.8171 37.3517 22.371 38.6039 23.1175C41.2046 24.6827 41.614 27.5242 40.7952 29.8119C40.1812 31.5336 38.8327 32.4969 37.1229 32.9183C34.4259 33.5925 31.8613 33.3156 29.5737 31.6179C28.7308 31.0159 28.1047 30.2212 27.6352 29.246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.136 27.753C17.3888 28.1262 17.5935 28.4633 17.8223 28.7884C18.4845 29.6794 19.532 29.9804 20.5795 29.5951C21.314 29.3303 21.5427 28.7162 21.627 28.0179C21.6632 27.6566 21.6632 27.2954 21.6632 26.9342C21.6632 22.8887 21.6632 18.8552 21.6632 14.8096C21.6632 14.617 21.6632 14.4123 21.6632 14.1956C22.9996 14.1956 24.2759 14.1956 25.5763 14.1956C25.5883 14.3521 25.6003 14.4725 25.6003 14.6049C25.6003 18.9154 25.6124 23.2258 25.5883 27.5362C25.5883 28.1985 25.492 28.8727 25.3234 29.5109C24.8298 31.3771 23.6016 32.5571 21.7234 33.0146C19.9414 33.448 18.1955 33.3517 16.534 32.4848C15.4383 31.9189 14.6557 31.0279 14.0898 29.9563C13.9935 29.7878 13.9573 29.6553 14.1741 29.5349C15.1614 28.957 16.1366 28.355 17.136 27.753Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_78",
    x: 0,
    y: 0,
    width: 55.1981,
    height: 55.1981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_78",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.322c3b52bfe83ef32754b790bafcb07f.svg";
export { ForwardRef as ReactComponent };